/* eslint-disable indent */
import {defineCustomElement, formatPrice} from 'extensions/ui-utils';
import {LitElement, html, nothing} from 'lit';
import stylesheet from './x-rma-summary.scss?as=stylesheet';

export class RMASummary extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			disableButton: {
				attribute: 'disable-button',
				type: Boolean
			},
			shipping: {
				type: Number
			},
			subTotal: {
				attribute: 'sub-total',
				type: Number
			},
			tax: {
				type: Number
			},
			total: {
				type: Number
			},
			valid: {
				type: Boolean
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {boolean}
		 */
		this.disableButton = false;

		/**
		 * @type {number}
		 */
		this.shipping = 0;

		/**
		 * @type {number}
		 */
		this.subTotal = 0;

		/**
		 * @type {number}
		 */
		this.tax = 0;

		/**
		 * @type {number}
		 */
		this.total = 0;

		/**
		 * @type {boolean}
		 */
		this.valid = false;
	}

	handleClick () {
		this.dispatchEvent(new CustomEvent('rma-summary:submit', {
			bubbles: true,
			composed: false
		}));
	}

	firstUpdated () {
		if (!this.disableButton) {
			const observer = new IntersectionObserver(
				([e]) => this.renderRoot.querySelector('#mobile-continue-button')?.classList?.toggle('is--sticky', e.intersectionRatio < 1),
				{
					rootMargin: '0px 0px -1px 0px',
					threshold: [1]
				}
			);

			observer.observe(this.renderRoot?.querySelector('#continue-button'));
		}
	}

	renderButton () {
		return this.disableButton
			? nothing
			: html`<button id="continue-button" @click="${this.handleClick}" ?disabled="${!this.valid}" class="continue-button">
				Continue to Return
			</button>`;
	}

	render () {
		return html`
			<div id="mobile-continue-button" class="mobile-sticky-button">
				<button @click="${this.handleClick}" ?disabled="${!this.valid}" class="continue-button">
					Continue to Return
				</button>
			</div>

			<div class="container">
				<h2 class="header">Return Summary</h2>
				<main class="main">
					<slot name="product" class="slot-product"></slot>

					<div class="row">
						<div class="label">Subtotal</div>
						<div class="value">${this.subTotal > 0 ? formatPrice(this.subTotal * -1) : '--'}</div>
					</div>

					<div class="row">
						<div class="label">Shipping</div>
						<div class="value">${this.shipping > 0 ? formatPrice(this.shipping) : 'TBD'}</div>
					</div>

					<div class="row">
						<div class="label">GST</div>
						<div class="value">${this.tax > 0 ? formatPrice(this.tax * -1) : '--'}</div>
					</div>
				</main>
				<footer class="footer">
					<div class="row">
						<div class="label">Estimated Credit</div>
						<div class="value">${this.total > 0 ? formatPrice(this.total) : 'TBD'}</div>
					</div>

					${this.renderButton()}
				</footer>
			</div>

			<slot name="helpful-info"></slot>
		`;
	}
};

defineCustomElement('x-rma-summary', RMASummary);
